/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

export class VarianceMktDivSgmntRptRequest {
  workingScenId: number;
  workingScenName: string;
  compareScenId: number;
  compareScenName: string;
  isBySubregion: boolean;
  subregionOrMktAreas: string[];
  planningMarkets: string[];
  mktDivs: string[];
  gmid: string;
  startYear: number;
  endYear: number;
  isByPlngMktOutput: boolean;
}
